import { createUseStyles, multiply, add, negative } from '@pushpay/styles';
export const useTextStyles = createUseStyles(theme => {
  const {
    TYPOGRAPHY: {
      FONT: {
        CAPITAL_LETTER_SCALE,
        DESCENDER_HEIGHT_SCALE
      },
      TEXT_STYLES
    }
  } = theme;
  const preventCollapsePx = 1;
  return {
    root: ({
      textStyle,
      isMobile
    }) => {
      const {
        COLOR,
        LINE_HEIGHT,
        SIZE,
        MOBILE_SIZE,
        FAMILY,
        WEIGHT
      } = TEXT_STYLES[textStyle];
      const fontSize = isMobile ? MOBILE_SIZE : SIZE;
      const textOffset = (LINE_HEIGHT - 1) / 2 + DESCENDER_HEIGHT_SCALE;
      const topSpace = multiply(fontSize, LINE_HEIGHT - CAPITAL_LETTER_SCALE);
      const heightCorrection = negative(add(topSpace, preventCollapsePx));
      const font = `${WEIGHT} ${fontSize} / ${LINE_HEIGHT} ${FAMILY}`;
      return {
        display: 'block',
        font,
        color: COLOR,
        margin: 0,
        padding: `${preventCollapsePx}px 0 0`,
        transform: `translateY(${textOffset}em)`,
        verticalAlign: 'baseline',
        '&:before': {
          content: '""',
          display: 'block',
          height: 0,
          marginTop: heightCorrection
        }
      };
    }
  };
});